import { takeLatest, takeEvery } from 'redux-saga'
import sitesActions from './sites/actions'
import fireRollCallActions from './fire-roll-call/actions'
import permissionsActions from './permissions/actions'
import reportActions from './reports/actions'
import featuresActions from './features/actions'
import reportViewerActions from './report-viewer/actions'
import passActions from './passes/actions'

import siteSaga from './sites/saga'
import fireRollCallSaga from './fire-roll-call/saga'
import permissionsSaga from './permissions/saga'
import featuresSaga from './features/saga'
import reportSaga from './reports/report/saga'
import reportTypesSaga from './reports/reportTypes/saga'
import reportViewerSaga from './report-viewer/saga'
import passesSaga from './passes/saga'

function* sagas() {
  yield takeLatest(sitesActions.fetchSites, siteSaga)
  yield takeLatest(fireRollCallActions.fetchFireRollCall, fireRollCallSaga)
  yield takeLatest(permissionsActions.fetchPermissions, permissionsSaga)
  yield takeLatest(featuresActions.fetchFeatures, featuresSaga)
  yield takeLatest(reportActions.fetchReport, reportSaga)
  yield takeLatest(reportActions.fetchReportTypes, reportTypesSaga)
  yield takeLatest(reportViewerActions.fetch, reportViewerSaga)
  yield takeEvery(passActions.fetchPasses, passesSaga)
}

export default sagas



// WEBPACK FOOTER //
// ./src/store/sagas.js